import React, { useCallback } from "react";
import { Confirmar } from "../../../../components";
import { useDispatch } from "react-redux";
import {
  usersPageCloseModal,
  usersPageDelete,
} from "../reducers/users-page-actions";
import { useToggle } from "react-use";

const STR = {
  title: "Excluir usuário",
  subtitle: "Você tem certeza que deseja excluir o usuário?",
};

function UsersPageDeleteUser({ id }) {
  const [wait, setWait] = useToggle();
  const dispatch = useDispatch();
  //
  const onConfirm = useCallback(() => {
    setWait(true);
    dispatch(usersPageDelete(id, setWait));
  }, [dispatch, id, setWait]);
  //
  const onCancel = useCallback(() => {
    dispatch(usersPageCloseModal());
  }, [dispatch]);

  return (
    <Confirmar
      titulo={STR.title}
      subtitulo={STR.subtitle}
      fnCancelar={onCancel}
      fnConfirmar={onConfirm}
      aguardar={wait}
    />
  );
}

export default UsersPageDeleteUser;
